import live from "./live";
import local from "./local";

export default {
  live,
  local
}